import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ChatComponent} from '../../components/chat/chat.component';

@Component({
    selector: 'page-chat',
    imports: [
        ChatComponent
    ],
    templateUrl: './chat.page.html',
    styleUrl: './chat.page.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { 'class': 'chat-container' }
})
export class ChatPage {
}
